import type { ComponentProps } from "react";

import { LoadingSpinner as CommonLoadingSpinner } from "@/shared/components/ui/loading-spinner";

const SHIELD_SRC = `${import.meta.env.VITE_CDN_BASE_URL}/assets/shield_128x148.webp`;

export default function LoadingSpinner(props: ComponentProps<typeof CommonLoadingSpinner>) {
  return <CommonLoadingSpinner src={SHIELD_SRC} {...props} />;
}
